import { createGlobalStyle } from 'styled-components';

// For global styles
const GlobalStyle = createGlobalStyle`
  iframe[width="0"] {
    display: none;
  }
`;

export default GlobalStyle;
